import { close } from "@/components/icons/SVGIcons";
import { Button } from "@/components/UI/Button";
import { IPanelSelection } from "@/store/savedPanelsStore";
import { renamePanelLabel } from "@/store/savedPanelsStoreACTIONS";
import { useAuth0 } from "@auth0/auth0-react";
import React, {
  FormEvent,
  forwardRef,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";

interface PanelProps {
  currentActiveTab: IPanelSelection;
  setCurrentActiveTab: React.Dispatch<SetStateAction<IPanelSelection>>;
  panelsData: IPanelSelection[];
  setShowRenameTooltip: React.Dispatch<SetStateAction<boolean>>;
}

const EditableTextRenameCP = forwardRef<HTMLDivElement, PanelProps>(
  (
    { currentActiveTab, setCurrentActiveTab, panelsData, setShowRenameTooltip },
    // eslint-disable-next-line no-unused-vars
    ref,
  ) => {
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
      setMaxLength(false);
    }, []);

    const inputRef = useRef<HTMLInputElement>(null);

    const [value, setValue] = useState(currentActiveTab.label || "");
    const [maxLength, setMaxLength] = useState(false);

    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      let input = event.target.value;
      const inputEvent = event.nativeEvent as InputEvent;

      // Allow only letters and numbers, removing all other characters
      input = input.replace(/[^a-zA-Z0-9 ]/g, "");

      if (
        value.length > 12 &&
        inputEvent.inputType != "deleteContentBackward"
      ) {
        setMaxLength(true);
        return;
      }

      setMaxLength(false);
      setValue(input);
    };

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      // LABELS NEED to be Unique
      const arrOfCurrentNames = panelsData!.map((config) => config.label);
      if (arrOfCurrentNames.includes(value)) {
        toast.error("Panel name already exists.");
        return;
      }

      const newActiveTab = { ...currentActiveTab, label: value };
      setCurrentActiveTab(newActiveTab);
      renamePanelLabel(newActiveTab, getAccessTokenSilently);
      toast.success("Saved panel name.");
      setShowRenameTooltip(false);
    };

    return (
      <div className="flex flex-row">
        <form onSubmit={handleSubmit}>
          <label>
            <input
              ref={inputRef}
              type="text"
              className="mr-1 flex w-full justify-start overflow-hidden rounded-md border  border-gray-400 bg-transparent pl-1"
              value={value}
              onChange={handleInput} // Blocks unwanted characters immediately
              autoFocus
            ></input>
          </label>
          <div className="">{maxLength ? "Maximum input length" : ""}</div>

          <div className="flex w-full justify-start pt-1">
            <Button variant="mainBlueAction" className="px-2">
              Rename
            </Button>
          </div>
        </form>
        <Button
          variant="exit"
          size="icon_sm"
          onClick={() => {
            setShowRenameTooltip(false);
          }}
        >
          {close}
        </Button>
      </div>
    );
  },
);

EditableTextRenameCP.displayName = "EditableTextRenameCP"; // Fix for ESLint
export default EditableTextRenameCP;
